import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import React from "react";
function Loading() {
    return (
        <FontAwesomeIcon icon={faCircleNotch} spin />
    );
}

export default Loading;